export enum VossTierTagType {
    Merge = 0,
    Align = 1,
    Require = 2,
    Activate = 3,
    Exclusivity = 4,
}

export const VossTierTagTypeText: Record<VossTierTagType, string> = {
    [VossTierTagType.Merge]: 'vossTierTagType.merge',
    [VossTierTagType.Align]: 'vossTierTagType.align',
    [VossTierTagType.Require]: 'vossTierTagType.require',
    [VossTierTagType.Activate]: 'vossTierTagType.activate',
    [VossTierTagType.Exclusivity]: 'vossTierTagType.exclusivity',
};

export const VossTierTagTypeDescription: Record<VossTierTagType, string> = {
    [VossTierTagType.Merge]: 'vossTierTagType.mergeDescription',
    [VossTierTagType.Align]: 'vossTierTagType.alignDescription',
    [VossTierTagType.Require]: 'vossTierTagType.requireDescription',
    [VossTierTagType.Activate]: 'vossTierTagType.activateDescription',
    [VossTierTagType.Exclusivity]: 'vossTierTagType.exclusivityDescription',
};

export const tierTagTypes = Object.keys(VossTierTagTypeText).map(Number) as VossTierTagType[];
